import React, { useRef, useEffect, useState } from "react";
import "./App.css";
import Payment from "./Payment";

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const [environmentJS, setEnvironmentJS] = useState(
    "https://uat-kpaymentgateway.new-kpgw.com/ui/v2/kinlinepayment.min.js"
  );

  const [config, setConfig] = useState({});

  const handleChangeConfig = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setConfig((values) => ({ ...values, [name]: value }));
    console.log(config);
  };

  const handleSubmitConfig = (event) => {
    event.preventDefault();

    setIsSubmit(true);
    setIsLoading(true);
    setTimeout(function () {
      console.log(config);
      console.log(environmentJS);
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div className="App">
      <section className="section">
        <h1 className="title">REACT HOOKS 16.11.0</h1>
        <h2 className="subtitle">
          Example integrade <strong>K Inline</strong>, Payment with React hooks
          16.11.0
        </h2>

        <div className="columns">
          <div className="column is-one-third">
            <div className="box">
              <div className="bd-index-custom-example">
                <h1 className="title">CONFIG</h1>

                <form onSubmit={handleSubmitConfig}>
                  <div className="field">
                    <label className="label is-small">Environment</label>
                    <div className="select is-small">
                      <select
                        value={environmentJS || ""}
                        onChange={(e) => setEnvironmentJS(e.target.value)}
                      >
                        <option value={""} disabled>
                          Choose a environment ...
                        </option>
                        <option value="https://sit-dev-kpaymentgateway.new-kpgw.com/ui/v2/kinlinepayment.min.js">
                          SIT-Sandbox-v2
                        </option>
                        <option value="https://uat-kpaymentgateway.new-kpgw.com/ui/v2/kinlinepayment.min.js">
                          UAT-Live V2
                        </option>
                        <option value="https://kpaymentgateway.kasikornbank.com/ui/v2/kinlinepayment.min.js">
                          Prod-Live V2
                        </option>
                        <option value="https://dev-kpaymentgateway.kasikornbank.com/ui/v2/kinlinepayment.min.js">
                          Prod-Sandbox V2
                        </option>

                        <option value="http://127.0.0.1:5500/Embedded-JS/k-payment-gateway/dist/kinlinepayment.min.js">
                          Local
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="field">
                    <label className="label is-small">apikey</label>
                    <div className="control">
                      <textarea
                        className="textarea is-small"
                        placeholder="apikey"
                        rows="2"
                        required
                        name="apikey"
                        value={config.apikey || ""}
                        onChange={handleChangeConfig}
                      ></textarea>
                    </div>
                  </div>

                  <div className="field">
                    <label className="label is-small">prefillbin</label>
                    <div className="control">
                      <input
                        className="input is-small"
                        type="text"
                        placeholder="prefillbin"
                        name="prefillbin"
                        value={config.prefillbin || ""}
                        onChange={handleChangeConfig}
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label className="label is-small">campaign-id</label>
                    <div className="control">
                      <input
                        className="input is-small"
                        type="text"
                        placeholder="eg. 00000001"
                        name="campaignId"
                        value={config.campaignId || ""}
                        onChange={handleChangeConfig}
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label className="label is-small">lang</label>
                    <div className="control">
                      <input
                        className="input is-small"
                        type="text"
                        placeholder="eg. TH, EN"
                        name="lang"
                        value={config.lang || ""}
                        onChange={handleChangeConfig}
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label className="label is-small">payment-timeout</label>
                    <div className="control">
                      <input
                        className="input is-small"
                        type="text"
                        placeholder="eg. 00000001"
                        name="paymentTimeout"
                        value={config.paymentTimeout || ""}
                        onChange={handleChangeConfig}
                      />
                    </div>
                  </div>

                  <button type="submit" className="button is-small is-primary">
                    Save
                  </button>
                </form>

                <br />

                <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                  <thead>
                    <tr>
                      <th>Field Name</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>apikey</td>
                      <td>
                        (Mandatory) Your public key Data Type: Varchar (50)
                      </td>
                    </tr>
                    <tr>
                      <td>amount</td>
                      <td>(Optional) Amount</td>
                    </tr>
                    <tr>
                      <td>currency</td>
                      <td>(Optional) Currency unit (Default THB)</td>
                    </tr>
                    <tr>
                      <td>prefillbin</td>
                      <td>(Optional) </td>
                    </tr>
                    <tr>
                      <td>campaign-id</td>
                      <td>
                        (Optional) BIN - Campaign is feature to support when
                        merchant set promotion by merchant able to specify
                        date/time and participating card promotion. Data Type:
                        Varchar (8)
                      </td>
                    </tr>
                    <tr>
                      <td>lang</td>
                      <td>
                        (Optional) Language in payment form (Default EN) Data
                        Type: Enum(‘EN’,’TH’)
                      </td>
                    </tr>

                    <tr>
                      <td>payment-timeout</td>
                      <td>
                        (Optional) payment timeout (second) not more than 1200
                      </td>
                    </tr>


                   
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="column is-half">
            {isSubmit ? (
              <>
                {!isLoading ? (
                  <Payment env={environmentJS} config={config} />
                ) : (
                  <div>Loading...</div>
                )}
              </>
            ) : (
              <>please fill config</>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
